"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LastVisitedProductsContext = _interopRequireDefault(require("./LastVisitedProductsContext"));

function LastVisitedProductsProvider(_ref) {
  var children = _ref.children,
      keepCount = _ref.keepCount;

  var handlersRef = _react.default.useRef([]);

  var _React$useState = _react.default.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      lastVisitedProducts = _React$useState2[0],
      setLastVisitedProducts = _React$useState2[1];

  var resetLastVisitedProducts = _react.default.useCallback(function () {
    return setLastVisitedProducts({
      lastVisitedProducts: []
    });
  }, [setLastVisitedProducts]);

  var addProductToLastVisit = _react.default.useCallback(function (v) {
    var id = v.id;
    var i = lastVisitedProducts.indexOf(id); // limit produktu vzdy max 5 produktu => odebrani nejstarsiho produktu

    var limitedProducts = lastVisitedProducts.length > keepCount ? lastVisitedProducts.shift() : lastVisitedProducts;
    return i >= 0 ? null : setLastVisitedProducts([].concat((0, _toConsumableArray2.default)(limitedProducts), [id]));
  }, [keepCount, lastVisitedProducts]);

  var removeProductFromLastVisited = _react.default.useCallback(function (v) {
    return function () {
      setLastVisitedProducts(function (p) {
        var i = lastVisitedProducts.indexOf(v.id);
        return i >= 0 ? [].concat((0, _toConsumableArray2.default)(lastVisitedProducts.slice(0, i)), (0, _toConsumableArray2.default)(lastVisitedProducts.slice(i + 1))) : p;
      });
    };
  }, [lastVisitedProducts]);

  _react.default.useEffect(function () {
    handlersRef.current.forEach(function (h) {
      return h(lastVisitedProducts);
    });
  }, [lastVisitedProducts]);

  return /*#__PURE__*/_react.default.createElement(_LastVisitedProductsContext.default.Provider, {
    value: {
      lastVisitedProducts: lastVisitedProducts,
      resetLastVisitedProducts: resetLastVisitedProducts,
      addProductToLastVisit: addProductToLastVisit,
      removeProductFromLastVisited: removeProductFromLastVisited,
      addChangeEventListener: function addChangeEventListener(h) {
        handlersRef.current = [].concat((0, _toConsumableArray2.default)(handlersRef.current || []), [h]);
      },
      removeChangeEventListener: function removeChangeEventListener(h) {
        var i = handlersRef.current.findIndex(function (x) {
          return x === h;
        });

        if (i > -1) {
          handlersRef.current = [].concat((0, _toConsumableArray2.default)(handlersRef.current.slice(0, i)), (0, _toConsumableArray2.default)(handlersRef.current.slice(i + 1)));
        }
      }
    }
  }, children);
}

process.env.NODE_ENV !== "production" ? LastVisitedProductsProvider.propTypes = {
  children: _propTypes.default.node,
  keepCount: _propTypes.default.number.isRequired
} : void 0;
LastVisitedProductsProvider.defaultProps = {
  children: null
};
var _default = LastVisitedProductsProvider;
exports.default = _default;